import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import Home from '@/pages/Home';
import Products from '@/pages/Products';
import ProductDetail from '@/pages/ProductDetail';
import Cart from '@/pages/Cart';
import Checkout from '@/pages/Checkout';
import Orders from '@/pages/Orders';
import OrderDetail from '@/pages/OrderDetail';
import Login from '@/pages/Login';
import CustomCakes from '@/pages/CustomCakes';
import Subscriptions from '@/pages/Subscriptions';
import AdminLogin from '@/pages/admin/AdminLogin';
import AdminDashboard from '@/pages/admin/AdminDashboard';
import PolicyPage from '@/pages/PolicyPage';
import { AuthProvider } from '@/context/AuthContext';
import { CartProvider } from '@/context/CartContext';
import { AdminAuthProvider } from '@/context/AdminAuthContext';
import '@/App.css';

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <AdminAuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/products" element={<Products />} />
              <Route path="/products/:slug" element={<ProductDetail />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/orders" element={<Orders />} />
              <Route path="/orders/:id" element={<OrderDetail />} />
              <Route path="/subscriptions" element={<Subscriptions />} />
              <Route path="/login" element={<Login />} />
              <Route path="/custom-cakes" element={<CustomCakes />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/privacy-policy" element={<PolicyPage />} />
              <Route path="/refund-policy" element={<PolicyPage />} />
              <Route path="/terms-and-conditions" element={<PolicyPage />} />
            </Routes>
            <Toaster />
          </BrowserRouter>
        </AdminAuthProvider>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
